<div class="row">
    <div class="col-12" style="margin-top: 100px;"></div>
</div>
<div class="container">
    <div class="row no-gutters justify-content-center">
        <div class="col-md-12">
            <div class="wrapper">
                <div class="container-fluid">
                    <div class="row no-gutters justify-content-center h-100">
                        <div class="col-md-12">
                            <h3 class="proeject-title proeject-title-2 mb-2">{{ developerViewData.developer_name }}</h3>
                            <div class="wrapper position-relative">
                                <!-- <img src="assets/images/building.jpg" alt="Project Image" class="img-fluid"> -->
                                <img [src]="shared.getDeveloperImageURL(developerViewData.developer_banner)"  class="img-fluid">

                                <div class="overlay position-absolute">
                                    <div class="d-flex mt-2">
                                        <button class="btn btn-light">
                                            <!-- <h2 class="text-black">{{ developerViewData.developer_logo }}</h2> -->
                                            <img [src]="shared.getDeveloperImageURL(developerViewData.developer_logo)" class="main-img">

                                            <!-- <h5 class="text-black">Reality</h5> -->
                                        </button>
                                    </div>
                                    <br>
                                    <p class="text-white text-large mt-3">
                                        {{ developerViewData.developer_description }}
                                    </p>
                                    <br>
                                    <h6 class="text-white">Contact</h6>
                                    <div class="d-flex">
                                        <a class="btn btn-light mr-2" href="mailto:customercare@direkt.ae">
                                            <i class="fas fa-envelope"></i> Email
                                        </a>
                                        <a class="btn btn-light" href="https://api.whatsapp.com/send?phone=971563584795&text=Hello%20I%20need%20information%20about%20properties%20of%20{{developerViewData.developer_name}}">
                                            <i class="fab fa-whatsapp"></i> WhatsApp
                                        </a>
                                    </div>
                                </div>
                            </div>
                             </div>
                    </div>
                </div>
            </div>

                            <div class="row mt-4">
                          <ng-container *ngFor="let propertyData of propertyList">
                             <div class="col-12 mb-4">
                              <app-common-property [propertyData]='propertyData'></app-common-property>
                             </div>
                           </ng-container>
                          </div>
                        <!-- </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>
